'use client';

import { memo } from 'react';
import { HeaderConnectionBannerItemId } from '@headless-workspace/core-domain';
import { getIcon } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';
import { LanguageHelpers } from '@headless-workspace/utils';
import {
    bookNow,
    ClientEnvKey,
    ConnectionBannerItem,
    ConnectionDataLayerLabel,
    useAppLocale,
    useClientData,
} from '../../../../../src';

type AppointmentConnectionBannerItemProps = {
    id: HeaderConnectionBannerItemId;
    label: string;
    ariaLabel: string;
    iconName: string;
};

export const AppointmentConnectionBannerItem: ComponentMemo<AppointmentConnectionBannerItemProps> = memo(
    ({ id, label, ariaLabel, iconName }) => {
        const { getClientEnvVariable } = useClientData();
        const locale = useAppLocale();

        const onMakeAppointment = () => {
            bookNow(getClientEnvVariable(ClientEnvKey.BooxiKey), LanguageHelpers.parseLanguage(locale));
        };

        return (
            <ConnectionBannerItem
                Icon={getIcon(iconName)}
                label={label}
                ariaLabel={ariaLabel}
                onClick={onMakeAppointment}
                dataLayer={{
                    label: ConnectionDataLayerLabel[id],
                }}
            />
        );
    },
);

AppointmentConnectionBannerItem.displayName = 'AppointmentConnectionBannerItem';
